import { otherApiClient } from ".";
export const getEditionCategoryList = async (param)=>{
    let { editionId  } = param;
    const { data  } = await otherApiClient.market("/edition-categories/".concat(editionId));
    return data;
};
/**
 * 에디션 카테고리 정보 조회 (무료체험, 가이드배너 등)
 * 엔드포인트: /edition-categories/{editionId}/page
 */ export const getEditionCategoryInfo = async (param)=>{
    let { editionId  } = param;
    const { data  } = await otherApiClient.market("/edition-categories/".concat(editionId, "/page"));
    return data;
};
export const getEditionCategoryProduct = async (param)=>{
    let { editionId , categoryId , ...rest } = param;
    const { data  } = await otherApiClient.market("/edition-categories/".concat(editionId, "/").concat(categoryId), {
        params: rest
    });
    return data;
};
/**
 * 마지막 depth 카테고리의 그룹화된 상품 리스트 조회
 */ export const getEditionCategoryGroupedProduct = async (param)=>{
    let { editionId , categoryId , ...rest } = param;
    const { data  } = await otherApiClient.market("/edition-categories/".concat(editionId, "/").concat(categoryId, "/grouped"), {
        params: rest
    });
    return data;
};
/**
 * 무료체험 자료 받기 (Claim)
 * 엔드포인트: POST /free-trial/claim
 */ export const claimFreeTrial = async (param)=>{
    let { productId , promotionId  } = param;
    const { data  } = await otherApiClient.market.post("/free-trial/claim", {
        productId,
        promotionId
    });
    return data;
};
/**
 * 이용권 첫 사용 여부 확인
 */ export const checkLicenseFirstUse = async (param)=>{
    let { membershipId  } = param;
    const { data  } = await otherApiClient.market("/memberships/license-history", {
        params: {
            membershipId
        }
    });
    return data;
};
